var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "History",
    clipPath: "url(#clip0_2741_144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6667 5C13.3833 5 6.66667 11.7167 6.66667 20H1.66667L8.15 26.4833L8.26667 26.7167L15 20H10C10 13.55 15.2167 8.33333 21.6667 8.33333C28.1167 8.33333 33.3333 13.55 33.3333 20C33.3333 26.45 28.1167 31.6667 21.6667 31.6667C18.45 31.6667 15.5333 30.35 13.4333 28.2333L11.0667 30.6C13.7833 33.3167 17.5167 35 21.6667 35C29.95 35 36.6667 28.2833 36.6667 20C36.6667 11.7167 29.95 5 21.6667 5ZM20 13.3333V21.6667L27.1333 25.9L28.3333 23.8833L22.5 20.4167V13.3333H20Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2741_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history_icon.bbb8bb0b4a3f3c4f1fe82b84c1225de6.svg";
export { ForwardRef as ReactComponent };